/* src/app/quickbooks/send-purchases/send-purchases-container/send-purchases-container.component.scss */
/*# sourceMappingURL=send-purchases-container.component.css.map */
